import pkg from '../../../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://api.v2.dev.activar.app/',
  authUrl: 'https://auth.dev.activar.app/',
  // shared with the agents portal; set once the site is registered in Google Cloud Console
  recaptchaSiteKey: '6Lf96GEtAAAAAH3cGXQ7Yzg2gZWVlMplO4MsNBFf',
  version: pkg.version,
};
